'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import {Scroller} from '@shared/Scroller/Scroller';
import Link from 'next/link';

import {ArticleType} from '@strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import styles from './Blog.module.scss';

type Props = {
  title: string;
  articles: Array<Partial<ArticleType>>;
};

export const Blog = ({articles, title}: Props) => {
  const onArticleClick = (props: Partial<ArticleType>) => {
    logTmrEvent('article.click', {
      article_name: props.cardTitle,
      category_name: 'main_landing',
      compilation_name: title,
    });
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      <Scroller variant="grid">
        {articles.map((article, index) => (
          <Link
            href={`/prostore/${article.href}`}
            className={styles.card}
            key={index}
            prefetch={false}
            onClick={() => onArticleClick(article)}
          >
            {article.cardBackgroundImage && (
              <div className={styles.card__imageContainer}>
                <ProxyImage
                  className={styles.card__image}
                  imageData={article.cardBackgroundImage}
                />
              </div>
            )}
            <h3 className={styles.card__title}>{article.cardTitle}</h3>
          </Link>
        ))}
      </Scroller>
    </div>
  );
};
